<template>
  <tr class="even:bg-white odd:bg-gray-50">
    <td class="px-4 py-4 text-sm text-gray-500 align-top">
      <a role="button" class="underline" @click.prevent="showContactRequest">
        {{ fullName }}
      </a>
    </td>
    <td class="px-4 py-4 text-sm text-gray-500 text-right align-top">
      {{ pipelineStage ? pipelineStage.name : '-' }}
    </td>
    <td class="px-4 py-4 text-sm text-gray-500 text-right">
      <span class="whitespace-nowrap">{{ createdAt }}</span>
      <div>
        {{ createdAtFromNow }}
      </div>
    </td>
  </tr>
</template>
<script>
import moment from 'moment';

export default {
  props: {
    contactRequest: {
      type: Object,
      required: true,
    },
  },
  computed: {
    fullName() {
      return `${this.contactRequest?.firstName || ''} ${
        this.contactRequest?.lastName || ''
      }`.trim();
    },
    pipelineStage() {
      return this.contactRequest?.pipelineStage || null;
    },
    createdAt() {
      return moment.utc(this.contactRequest.createdAt).local().format('YYYY-MM-DD HH:mm');
    },
    createdAtFromNow() {
      return moment.utc(this.contactRequest.createdAt).local().fromNow();
    },
  },
  methods: {
    showContactRequest() {
      this.$modal.show({
        component: 'ContactRequestModal',
        props: {
          contactRequestId: this.contactRequest.id,
        },
        on: {},
        hideEvent: 'hide',
      });
    },
  },
};
</script>
